/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioTipoCuentaBancariaVistaProps } from '../interfaces';

const FormularioTipoCuentaBancariaVista: React.FunctionComponent<IFormularioTipoCuentaBancariaVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tipoCuentaBancaria,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tipoCuentaBancaria.agregarTipoCuentaBancaria'
                                : 'tipoCuentaBancaria.modificarTipoCuentaBancaria'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        inputProps={{ maxLength: 10 }}
                        label={<Texto id="tipoCuentaBancaria.codigoTipoCuentaBancaria" display="inline" />}
                        name="CodigoTipoCuentaBancaria"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={tipoCuentaBancaria.CodigoTipoCuentaBancaria}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        inputProps={{ maxLength: 50 }}
                        label={<Texto id="tipoCuentaBancaria.nombreTipoCuentaBancaria" display="inline" />}
                        name="NombreTipoCuentaBancaria"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoCuentaBancaria.NombreTipoCuentaBancaria}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={tipoCuentaBancaria.EstadoTipoCuentaBancaria}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="tipoCuentaBancaria.estadoTipoCuentaBancaria" display="inline" />}
                        name="EstadoTipoCuentaBancaria"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioTipoCuentaBancariaVista;
